var exports = {
  "Sc": "UserArea.module__userAreaInnerWrapper___XzhjRU",
  "cU": "UserArea.module__userAreaContainer___XzhjRU",
  "jC": "UserArea.module__popoutContainer___XzhjRU",
  "oT": "UserArea.module__voiceConnectionWrapper___XzhjRU",
  "eF": "UserArea.module__userInfo___XzhjRU",
  "vu": "UserArea.module__active___XzhjRU",
  "N6": "UserArea.module__userInfoText___XzhjRU",
  "nT": "UserArea.module__userName___XzhjRU",
  "Mp": "UserArea.module__guildTag___XzhjRU",
  "ag": "UserArea.module__userStatus___XzhjRU",
  "uh": "UserArea.module__userStatusLabel___XzhjRU" + " " + "UserArea.module__userStatus___XzhjRU",
  "XW": "UserArea.module__userCustomStatus___XzhjRU" + " " + "UserArea.module__userStatus___XzhjRU",
  "oM": "UserArea.module__hoverRoll___XzhjRU",
  "n6": "UserArea.module__defaultState___XzhjRU",
  "yo": "UserArea.module__hovered___XzhjRU",
  "EE": "UserArea.module__forceHover___XzhjRU",
  "gO": "UserArea.module__controlsContainer___XzhjRU",
  "uH": "UserArea.module__controlButton___XzhjRU",
  "DY": "UserArea.module__contextMenuHover___XzhjRU",
  "r9": "UserArea.module__disabled___XzhjRU",
  "j7": "UserArea.module__gameModeOn___XzhjRU",
  "pd": "UserArea.module__controlIcon___XzhjRU",
};

module.exports = exports;
